import React from 'react'

export const DevelopmentTab: React.FC = () => {
  const isDevelopment =
    window.location.hostname.includes('localhost') ||
    window.location.hostname.includes('develop')

  return isDevelopment ? (
    <div
      className='absolute top-0 left-0 right-0 w-full bg-red-600/50
     text-white text-center py-2 font-bold z-50 text-sm shadow-md
     pointer-events-none'
    >
      Ambiente de desenvolvimento
    </div>
  ) : null
}
